const analyticSectionEnum = Object.freeze({
    HEADER: 5,
    BODY: 10,
    FOOTER: 15
});
export default analyticSectionEnum;
